var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "StoneCutCushion",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-stone-cut-cushion","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M171.2.3H78.8C36.5.3 1.9 34.1.4 76l-1.6.8 1.6 3V171c0 43.3 35.2 78.5 78.5 78.5h92.3c43.3 0 78.5-35.2 78.5-78.5V78.8c0-43.2-35.3-78.5-78.5-78.5zm46.7 119.2l-25.7-27.9 4.7-31.6 42.2 18.3-21.2 41.2zm-119.5 71l-31.4-34-.6-62.1 35.1-36.9 46.1.3L183 94.9l-.6 61-31.9 34.6H98.4zm43.7 9l-17.7 19.2-17.7-19.2h35.4zM65 82.8l-3.8-25.5 27.9.2L65 82.8zM57.5 104l.4 42.6L38.1 125l19.4-21zm8 64.1l20.7 22.4H62.4l3.1-22.4zM110 48.6l14.4-15.1L139 48.8l-29-.2zm74.4 34.8L160.2 58l28 .2-3.8 25.2zm-.7 84.3l3.1 22.8h-24.1l21-22.8zm8.2-63.1l18.8 20.5-19.3 21 .5-41.5zm10.7-51.8l23.7-16.2c7.1 9.3 12 20.4 13.7 32.4l-37.4-16.2zm-51.1-3.9L131.6 28l42.1-17.8-.3-.8c.5 0 1.1 0 1.6.1l12.3 39.7-35.8-.3zm-22-29.8V9.3h23l-23 9.8zm-10.2.4L95.7 9.3h23.6v10.2zm-2.4 8.8L97.7 48.5l-36.4-.3L71.5 9.7c.6-.1 1.3-.1 1.9-.2l43.5 18.8zM52.8 45.1l-23-15.4c8.7-8.7 19.7-15.1 32-18.2l-9 33.6zM57.2 91L31 119.5 11 80.7l41.6-21.3L57.2 91zm-26.3 39.5l26.7 29.1-3.9 28.5-44.3-14.4v-1.5l21.5-41.7zm16.5 65l-24.4 17c-6.2-8.4-10.6-18.3-12.5-29l36.9 12zm47 4l22.7 24.6L74 239.9l-10.6-40.4h31zm24.9 33.4v7.8H98.1l21.2-7.8zm10.2-.4l21.2 8.1h-21.2v-8.1zm46 8L132 223.8l22.4-24.3h31.8l-10.4 41h-.3zm65.1-67.1L195.7 189l-4.1-29.8 26.3-28.7 22.1 42.8.6-.3v.4zm-1 9.9c-2 11.2-6.6 21.5-13.3 30.1l-24.5-17.1 37.8-13zM225.2 125l15.4-29.9v59.8L225.2 125zm-4.9-95.3l-24.5 16.8-11.1-35.8c13.8 2.7 26.1 9.5 35.6 19zM23.8 36.5l23.4 15.6L9.8 71.3c1.4-13 6.4-24.9 14-34.8zm-.2 88.5L9.3 152.6V97.4L23.6 125zm5.2 94.4l25.8-18 9.9 37.8c-13.8-2.9-26.2-10-35.7-19.8zm156.6 19.8l9.3-36.8 25.6 17.8c-9.4 9.4-21.4 16.2-34.9 19z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/stone-cut-cushion.svg